<template>
    <div class="search-csps">
        <v-autocomplete
            v-model="csps"
            :items="items"
            :search-input.sync="search"
            class="search-container rounded-0"
            label="Catégorie(s) socioprofessionnelle(s)"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="label"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :multiple="true"
            :clearable="true"
            @input="search = null"
        >
            <template slot="selection" slot-scope="data">
                <div class="selected-container" v-if="data.item">
                    <typo name="body-14-normal">{{ `${data.item.label}` }} </typo>
                    <v-icon small color="black" class="reset" @click="removeItem(data.item)">
                        mdi-close-circle
                    </v-icon>
                </div>
            </template>
            <template slot="item" slot-scope="data">
                <div>
                    <typo name="body-14-normal">{{ `${data.item.label}` }} </typo>
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            csps: null,
            search: null,
        };
    },
    mounted() {
        this.csps = this.value;
    },
    methods: {
        removeItem(item) {
            this.csps = this.csps.filter(type => type !== item.code);
        },
    },
    watch: {
        async csps(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.csps = _value;
        },
    },
    computed: {
        items() {
            return this.$privateDico.convention.cspFilterItems;
        },
    },
};
</script>

<style lang="sass" scoped>
.search-csps
    display: flex
    align-items: center
    margin: 8px 0

.selected-container
    color: $color-secondary
    background: $color-background
    height: 28px
    display: flex
    align-items: center
    padding: 0 10px
    border: 1px solid white
    margin: 4px 0
    .typo
        margin-right: 8px
</style>
